export default __webpack_public_path__ + "static/media/GunjanBhargava2021.1f6cf642.pdf";